import { MenuItem, MenuItems } from 'types.ts';
import ListIcon from '@mui/icons-material/List';
import Checklist from '@mui/icons-material/Checklist';
import BatchPredictionSharpIcon from '@mui/icons-material/BatchPredictionSharp';

const workflow: MenuItem = {
  id: 'workflows-group',
  title: 'Workflows',
  type: 'group',
  children: [
    {
      id: 'workflows',
      title: 'Workflows',
      type: 'item',
      url: `/workflows`,
      icon: ListIcon,
      breadcrumbs: false,
    },
    {
      id: 'workflow-executions',
      title: 'Workflow Executions',
      type: 'item',
      url: `/workflow-executions`,
      icon: Checklist,
      breadcrumbs: false,
    },
    {
      id: 'batch-jobs',
      title: 'Batch Jobs',
      type: 'item',
      url: '/batch-jobs',
      icon: BatchPredictionSharpIcon,
      breadcrumbs: false,
    },
    {
      id: 'batch-job-executions',
      title: 'Batch Job Executions',
      type: 'item',
      url: '/batch-job-executions',
      icon: Checklist,
      breadcrumbs: false,
    },
  ],
};

const projectMenuItems: MenuItems = {
  items: [workflow],
};

export default projectMenuItems;
